import {TaxRule} from '@store/common/organisation.enums';
import {Pagination} from '@store/common/pagination.model';
import {TableFilter, TableFilterType} from '@store/common/tableFilter.model';
import {Waste} from '../wasteFamilies';
import {ServiceKind} from '../serviceKinds';

export interface AccountFilters {
  search: string;
  tableFilters: TableFilter[];
  hideExpired: boolean;
}

export namespace AccountFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.CLIENT_ORGANISATION,
    TableFilterType.CLIENT_ORGANISATION_UNIT,
    TableFilterType.SUPPLIER_ORGANISATION,
    TableFilterType.SUPPLIER_ORGANISATION_UNIT,
  ]);
}

export interface AccountPagination extends Pagination {
  data: Account[];
}

export interface AccountUI {
  id: number;
  selected: boolean;
}


export interface ManageAccount extends Partial<Account> {
  wasteId?: number;
  serviceKindId?: number;
}

export interface Account {
  id: number;
  waste: Waste;
  serviceKind: ServiceKind;
  taxRule: TaxRule;
  sellingAccountNumber: string;
  sellPctVat: number;
  sellVatAccount: string;
  sellFeeType: string;
  buyingAccountNumber: string;
  buyPctVat: number;
  buyVatAccount: string;
  buyFeeType: string;
  validFromDate: Date;
  validToDate: Date;
}


